import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Avatar, Tooltip, Typography } from '@thinknet-gmbh/platform-common-ui';

import { ROUTES } from 'src/components/app/app-routes.constants';
import { JOBS_PAGES } from 'src/pages/jobs/jobs.constants';
import { IJob } from 'src/pages/jobs/jobs.interfaces';
import { EMPLOYEE_PAGES } from 'src/pages/employee/employee.constants';

import JobsListTableRowPopover from './jobs-list-table-row-popover.component';
import { AvatarWrapper, StyledRowTable } from './jobs-list-table.styles';

interface IProps {
  locationState: { companyId: string; departmentId: string };
  jobsLocations: any;
  getCurrentJob: (value: IJob, modal: string) => void;
}

const JobsListTable = ({ jobsLocations, getCurrentJob, locationState }: IProps) => {
  const { t } = useTranslation(['common', 'jobs']);
  const navigate = useNavigate();

  return (
    <StyledRowTable
      dataSource={jobsLocations}
      rowKey={record => record._id}
      onRow={record => ({
        onClick: () =>
          navigate(`${ROUTES.jobs}/${JOBS_PAGES.jobDetailsPage}?id=${record.job._id}`, {
            state: locationState,
          }),
      })}
      pagination={false}
    >
      <StyledRowTable.Column
        title={t('common:labels.jobTitle')}
        dataIndex={['job', 'title']}
        key="job_title"
        sorter={(a: any, b: any) => a.job.title.localeCompare(b.job.title)}
        render={title => <Typography>{title}</Typography>}
      />
      <StyledRowTable.Column
        title={t('jobs:labels.jobPlaces')}
        dataIndex="jobSupervisors"
        key="jobPlacesCount"
        render={jobSupervisors => (
          <Typography>
            {jobSupervisors.reduce(
              (partialSum: number, a: any) => partialSum + a.jobPlacesCount,
              0
            )}
          </Typography>
        )}
      />
      <StyledRowTable.Column
        title={t('jobs:labels.assignedEmployee')}
        dataIndex="jobSupervisors"
        key="assignedMembers"
        render={jobSupervisors => (
          <AvatarWrapper>
            <Avatar.Group>
              {jobSupervisors.flatMap((supervisor: any) =>
                supervisor.assignedMembers.map((employee: any) => (
                  <div
                    key={employee._id}
                    onClick={e => {
                      e.stopPropagation();
                      navigate(
                        `${ROUTES.employee}?type=${EMPLOYEE_PAGES.employeeProfile}&id=${employee._id}`
                      );
                    }}
                  >
                    <Tooltip title={employee.profile.displayName} placement="bottom">
                      <Avatar size={24} key={employee._id} avatar={employee.profile.avatarUrl} />
                    </Tooltip>
                  </div>
                ))
              )}
            </Avatar.Group>
          </AvatarWrapper>
        )}
      />
      <StyledRowTable.Column
        title={t('common:labels.action')}
        render={(record: any) => (
          <JobsListTableRowPopover
            record={{
              ...record,
              departmentId: locationState.departmentId,
              companyId: locationState.companyId,
            }}
            getCurrentJob={getCurrentJob}
          />
        )}
        width={50}
      />
    </StyledRowTable>
  );
};

export default JobsListTable;
